import React from 'react';
import GoogleMapReact from 'google-map-react';
import Firebase from 'firebase';
import Item from './item';
import { Popover } from 'reactstrap';


export default class main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center: { lat: -33.4164986, lng: -70.6007971 },
            zoom: 11,
            registros: []
        }
    }

    componentWillReceiveProps(nextProps) {
        var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/"+ nextProps.form + "/" + nextProps.lastVersion + "/raw/data");
        dataRef.orderByChild("global/user/rut").equalTo(nextProps.auditor)
            .on('value', snap => {
                if (snap) {
                    var options = new Array;
                    snap.forEach(function (childSnapshot) {
                        var propFecha = new Date(nextProps.fecha);
                        var regFecha = new Date(childSnapshot.val().global.date.server)
                        if (Math.abs(propFecha.getTime() - regFecha.getTime()) < 86400000) {
                            options.push(childSnapshot.val())
                        }
                    });
                    this.setState({ registros: options })
                }
            })
    }

    render() {
        return (
            <div style={{ width: '100%', height: '400px' }}>
                <GoogleMapReact
                    defaultCenter={this.state.center}
                    defaultZoom={this.state.zoom}
                    onChildClick={(e) => { this.setState({ target: "item" + e, popoverOpen: !this.state.popoverOpen, reg: Object.values(this.state.registros)[e] }); this.props.regSelected(Object.values(this.state.registros)[e]) }}
                >
                    {
                        this.state.registros.map((reg, index) => (
                            <div
                                id={"item" + index}
                                lat={reg.global.gps.lat}
                                lng={reg.global.gps.lon}>
                                <Item
                                    reg={reg}
                                />
                            </div>
                        ))
                    }
                </GoogleMapReact>
                <Popover placement="bottom" isOpen={this.state.popoverOpen} target={this.state.target} toggle={() => this.setState({ popoverOpen: !this.state.popoverOpen })}>
                    <div>
                        Informacion extra aqui
                    </div>
                </Popover>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/cafe-haiti/mapa/mapa.js